import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { AppProvider } from "./store";
import Header from "./components/Header";
import PromoBanner from "./components/PromoBanner";
import Hero from "./components/Hero";
import ProductShowcase from "./components/ProductShowcase";
import PetSection from "./components/PetSection";
import SneakerSection from "./components/SneakerSection";
import HowItWorks from "./components/HowItWorks";
import Features from "./components/Features";
import Specs from "./components/Specs";
import AltPayments from "./components/AltPayments";
import Reviews from "./components/Reviews";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CartSheet from "./components/CartSheet";
import CheckoutSuccess from "./components/CheckoutSuccess";
import CheckoutCancel from "./components/CheckoutCancel";
import TrackVisits from "./components/TrackVisits";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";

const Home = () => (
  <>
    <Hero />
    <PetSection />
    <SneakerSection />
    <ProductShowcase />
    <Reviews />
    <AltPayments />
    <FAQ />
  </>
);

// Conditionally render the public chrome (header, footer, cart) outside admin routes.
const PublicShell = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <PromoBanner />
      <Header />
      <main>{children}</main>
      <Footer />
      <CartSheet />
    </>
  );
};

function App() {
  return (
    <AppProvider>
      <div className="App" data-testid="velora-app">
        <BrowserRouter>
          <TrackVisits />
          <PublicShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </PublicShell>
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
